import logo from './logo.svg';
import './App.css';
import { Navigate, Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Home from './components/Home.js';
import Header from './components/Header';
import Footer from './components/Footer';
import NavbarMenu from './components/NavbarMenu.js';
import About from './components/About';
import Chancellor from './components/Chancellor';
import ViceChancellor from './components/ViceChancellor';
import Department from './components/Department.js';
import SpecialCellsCommittees from './components/SpecialCellsCommittees.js';
import VedaDepartment from './components/VedaDepartment.js';
import GrammarDepartments from './components/GrammarDepartment.js';
import AstrologyDepartment from './components/AstrologyDepartment.js';
import DepartmentDharmaStudies from './components/DepartmentDharmaStudies.js';
import DepartmentHinduStudies from './components/DepartmentHinduStudies.js';
import LiteratureDepartment from './components/LiteratureDepartment.js';
import FacultyPhilosophy from './components/FacultyPhilosophy.js';
import DepartmentYoga from './components/DepartmentYoga.js';
import SaraswatiCivilizationResearchCenter from './components/SaraswatiCivilizationResearchCenter.js';
import ResearchandPublication from './components/ResearchandPublication.js';
import KathKapisthalaResearchCenter from './components/KathKapisthalaResearchCenter.js';
import MaharishiValmikiResearchCenter from './components/MaharishiValmikiResearchCenter.js';
import IndianKnowledgeTraditionResearchTrainingCenter from './components/IndianKnowledgeTraditionResearchTrainingCenter.js';
import KosKurukshetraResearchTrainingCenter from './components/KosKurukshetraResearchTrainingCenter.js';
import VedaDiploma from './components/VedaDiploma.js';
import VastuShastraDiploma from './components/VastuShastraDiploma.js';
import KarmakandaPourohityaDiploma from './components/KarmakandaPourohityaDiploma.js';
import JyotishDiploma from './components/JyotishDiploma.js';
import YogaDiploma from './components/YogaDiploma.js';
import GitaMeJeevanPrabandhanDiploma from './components/GitaMeJeevanPrabandhanDiploma.js';
import SanskritBhashaDakshataDiploma from './components/SanskritBhashaDakshataDiploma.js';
import EnglishHindiEnglishTranslationDiploma from './components/EnglishHindiEnglishTranslationDiploma.js';


import NotFoundPage from './components/NotFoundPage.js';
import Entry from './components/Entry.js';
import Library from './components/Library.js';
import Exam from './components/Exam.js';
import Dormitory from './components/Dormitory.js';
import StaffDirectory from './components/StaffDirectory.js';
import Miscellaneous from './components/Miscellaneous.js';
import AcademicCalendar from './components/AcademicCalendar.js';
import TimetableTable from './components/Timetable.js';
import VisionandMission from './components/VisionandMission.js';
import Registrar from './components/Registrar.js';
import UniversityAct from './components/UniversityAct.js';
import CampusView from './components/CampusView.js';
import GuideMap from './components/GuideMap.js';
import UniversityAnthem from './components/UniversityAnthem.js';
import ExecutiveCouncil from './components/ExecutiveCouncil.js';
import AcademicCouncil from './components/AcademicCouncil.js';
import FinanceCommittee from './components/FinanceCommittee.js';
import AcademicPlanningBoard from './components/AcademicPlanningBoard.js';
import UniversityCourt from './components/UniversityCourt.js';
import Proctor from './components/Proctor.js';
import DeanofAcademics from './components/DeanofAcademics.js';
import DeanofStudentWelfare from './components/DeanofStudentWelfare.js';
import DeanofColleges from './components/DeanofColleges.js';
import ChiefWarden from './components/ChiefWarden.js';
import FinanceOfficer from './components/FinanceOfficer.js';
import ControllerofExaminations from './components/ControllerofExaminations.js';
import ChiefLibrarian from './components/ChiefLibrarian.js';
import FacultyHead from './components/FacultyHead.js';
import Ombudsman from './components/Ombudsman.js';
import Chancellormessage from './components/Chancellormessage.js';
import ViceChancellormessage from './components/ViceChancellormessage.js';
import Registrarmessage from './components/Registrarmessage.js';
import NoticesandTenders from './components/NoticesandTenders.js';
import RighttoInformation from './components/RighttoInformation.js';
import Help from './components/Help.js';
import NCC from './components/NCC.js';
import NSS from './components/NSS.js';
import SportsandGames from './components/SportsandGames.js';
import CulturalActivities from './components/CulturalActivities.js';
import RegisteredResearchScholars from './components/RegisteredResearchScholars.js';
import Convocation from './components/Convocation.js';
import GuestHouse from './components/GuestHouse.js';
import HealthCenter from './components/HealthCenter.js';
import YajnaHall from './components/YajnaHall.js';
import ComputerLab from './components/ComputerLab.js';
import YogaHall from './components/YogaHall.js';
import Canteen from './components/Canteen.js';
import ViceChancellorsOffice from './components/ViceChancellorsOffice.js';
import RegistrarOffice from './components/RegistrarOffice.js';
import UniversityStaff from './components/UniversityStaff.js';
import UniversityOfficials from './components/UniversityOfficials.js';

import PublicRelationsOfficerOffice from './components/PublicRelationsOfficerOffice.js';
import About_Eng from './components/About_Eng.js';
import Header_Eng from './components/Header_Eng.js';
import Home_Eng from './components/Home_Eng.js';
import VisionandMission_Eng from './components/VisionandMission_Eng.js';
import Chancellormessage_Eng from './components/Chancellormessage_Eng.js';
import ViceChancellormessage_Eng from './components/ViceChancellormessage_Eng.js';
import Registrarmessage_Eng from './components/Registrarmessage_Eng.js';
import UniversityAnthem_Eng from './components/UniversityAnthem_Eng.js';
import CampusView_Eng from './components/CampusView_Eng.js';
import GuideMap_Eng from './components/GuideMap_Eng.js';
import UniversityStaff_Eng from './components/UniversityStaff_Eng.js';
import ExecutiveCouncil_Eng from './components/ExecutiveCouncil_Eng.js';
import AcademicCouncil_Eng from './components/AcademicCouncil_Eng.js';
import FinanceCommittee_Eng from './components/FinanceCommittee_Eng.js';
import AcademicPlanningBoard_Eng from './components/AcademicPlanningBoard_Eng.js';
import UniversityCourt_Eng from './components/UniversityCourt_Eng.js';
import Chancellor_Eng from './components/Chancellor_Eng.js';
import ViceChancellor_Eng from './components/ViceChancellor_Eng.js';
import Registrar_Eng from './components/Registrar_Eng.js';
import Proctor_Eng from './components/Proctor_Eng.js';
import DeanofAcademics_Eng from './components/DeanofAcademics_Eng.js';
import DeanofStudentWelfare_Eng from './components/DeanofStudentWelfare_Eng.js';
import DeanofColleges_Eng from './components/DeanofColleges_Eng.js';
import ChiefWarden_Eng from './components/ChiefWarden_Eng.js';
import FinanceOfficer_Eng from './components/FinanceOfficer_Eng.js';
import ControllerofExaminations_Eng from './components/ControllerofExaminations_Eng.js';
import ChiefLibrarian_Eng from './components/ChiefLibrarian_Eng.js';
import FacultyHead_Eng from './components/FacultyHead_Eng.js';
import Ombudsman_Eng from './components/Ombudsman_Eng.js';
import SpecialCellsCommittees_Eng from './components/SpecialCellsCommittees_Eng.js';
import VedaDepartmentEng from './components/VedaDepartment_Eng.js';
import AstrologyDepartment_Eng from './components/AstrologyDepartment_Eng.js';
import DepartmentDharmaStudies_Eng from './components/DepartmentDharmaStudies_Eng.js';
import LiteratureDepartment_Eng from './components/LiteratureDepartment_Eng.js';
import DepartmentHinduStudies_Eng from './components/DepartmentHinduStudies_Eng.js';
import FacultyPhilosophy_Eng from './components/FacultyPhilosophy_Eng.js';
import DepartmentYoga_Eng from './components/DepartmentYoga_Eng.js';
import ResearchandPublication_Eng from './components/ResearchandPublication_Eng.js';
import KathKapisthalaResearchCenter_Eng from './components/KathKapisthalaResearchCenter_Eng.js';
import MaharishiValmikiResearchCenter_Eng from './components/MaharishiValmikiResearchCenter_Eng.js';
import KosKurukshetraResearchTrainingCenter_Eng from './components/KosKurukshetraResearchTrainingCenter_Eng.js';
import VedaDiploma_Eng from './components/VedaDiploma_Eng.js';
import VastuShastraDiploma_Eng from './components/VastuShastraDiploma_Eng.js';
import KarmakandaPourohityaDiploma_Eng from './components/KarmakandaPourohityaDiploma_Eng.js';
import IndianKnowledgeTraditionResearchTrainingCenter_Eng from './components/IndianKnowledgeTraditionResearchTrainingCenter_Eng.js';
import SaraswatiCivilizationResearchCenter_Eng from './components/SaraswatiCivilizationResearchCenter_Eng.js';
import VedaDepartment_Eng from './components/VedaDepartment_Eng.js';
import Department_Eng from './components/Department_Eng.js';
import UniversityAct_Eng from './components/UniversityAct_Eng.js';
import JyotishDiploma_Eng from './components/JyotishDiploma_Eng.js';
import YogaDiploma_Eng from './components/YogaDiploma_Eng.js';
import SanskritBhashaDakshataDiploma_Eng from './components/SanskritBhashaDakshataDiploma_Eng.js';
import EnglishHindiEnglishTranslationDiploma_Eng from './components/EnglishHindiEnglishTranslationDiploma_Eng.js';

import Library_Eng from './components/Library_Eng.js';
import Exam_Eng from './components/Exam_Eng.js';
import Dormitory_Eng from './components/Dormitory_Eng.js';
import NoticesandTenders_Eng from './components/NoticesandTenders_Eng.js';
import RighttoInformation_Eng from './components/RighttoInformation_Eng.js';
import StaffDirectory_Eng from './components/StaffDirectory_Eng.js';
import Miscellaneous_Eng from './components/Miscellaneous_Eng.js';
import AcademicCalendar_Eng from './components/AcademicCalendar_Eng.js';
import NCC_Eng from './components/NCC_Eng.js';
import NSS_Eng from './components/NSS_Eng.js';
import SportsandGames_Eng from './components/SportsandGames_Eng.js';
import CulturalActivities_Eng from './components/CulturalActivities_Eng.js';
import RegisteredResearchScholars_Eng from './components/RegisteredResearchScholars_Eng.js';
import Convocation_Eng from './components/Convocation_Eng.js';
import GuestHouse_Eng from './components/GuestHouse_Eng.js';
import HealthCenter_Eng from './components/HealthCenter_Eng.js';
import YajnaHall_Eng from './components/YajnaHall_Eng.js';
import ComputerLab_Eng from './components/ComputerLab_Eng.js';
import YogaHall_Eng from './components/YogaHall_Eng.js';
import Canteen_Eng from './components/Canteen_Eng.js';
import ViceChancellorsOffice_Eng from './components/ViceChancellorsOffice_Eng.js';
import RegistrarOffice_Eng from './components/RegistrarOffice_Eng.js';
import UniversityOfficials_Eng from './components/UniversityOfficials_Eng.js';
import PublicRelationsOfficerOffice_Eng from './components/PublicRelationsOfficerOffice_Eng.js';
import Help_Eng from './components/Help_Eng.js';
import Entry_Eng from './components/Entry_Eng.js';
import Timetable_Eng from './components/Timetable_Eng.js';
import GrammarDepartment_Eng from './components/GrammarDepartment_Eng.js';
import GitaMeJeevanPrabandhanDiploma_Eng from './components/GitaMeJeevanPrabandhanDiploma_Eng.js';

import Curriculum from './components/Curriculum.js';
import Curriculum_Eng from './components/Curriculum_Eng.js';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Images from './components/Dashboard/Images';
import Notifications1 from './components/Dashboard/Notifications';
import Links from './components/Dashboard/Links';
import Login from './components/Login/login';
import Dashboard from './components/Dashboard/Dashboard';
import Directory from './components/Dashboard/Directory';
import Home1 from './components/Dashboard/Home';
import GalleryPage from './components/GalleryPage.js';
import Navbar_Eng from './components/Navbar_Eng.js';
import Footer_Eng from './components/Footer_Eng.js';
import Scholarship from './components/Scholarship.js';
import SiteMap from './components/SiteMap.js';
import BlockNotifications from './components/Dashboard/BlockNotifications/BlockNotifications.js';
import RegistrationForm from './RegistrationPage/RegistrationForm.js';
import BaseUrl from './base-api.js';
import { useEffect, useState } from 'react';
import axios from 'axios';
import ViewAllNotices from './components/ViewAllNotices.js';




function AppContent() {





  return (
    <>
      {/* <Header /> */}
      {/* <NavbarMenu /> */}
      <Routes>
        <Route path='/hi' element={<Home />} />
        <Route path='/hi/विश्वविद्यालय/विश्वविद्यालय-के-बारे-में' element={<About />} />
        <Route path='/hi/विश्वविद्यालय/दृष्टि-ध्येय-एवं-उद्देश्य' element={< VisionandMission />} />
        <Route path='/hi/विश्वविद्यालय/कुलाधिपति-संदेश' element={<Chancellormessage />} />
        <Route path='/hi/विश्वविद्यालय/कुलपति-संदेश' element={<ViceChancellormessage />} />
        <Route path='/hi/विश्वविद्यालय/कुलसचिव-संदेश' element={<Registrarmessage />} />
        <Route path='/hi/विश्वविद्यालय/कुलगीत' element={<UniversityAnthem />} />
        <Route path='/hi/विश्वविद्यालय/विश्वविद्यालय-सदस्य' element={<UniversityStaff />} />

        <Route path='/hi/विश्वविद्यालय/परिसर-दृश्य' element={<CampusView />} />
        <Route path='/hi/विश्वविद्यालय/मार्गदर्शक-चित्र' element={<GuideMap />} />
        <Route path='/hi/विश्वविद्यालय/विश्वविद्यालय-अधिनियम' element={<UniversityAct />} />



        <Route path='/hi/प्रशासन/वैधानिक-निकाय/कार्य-परिषद्' element={<ExecutiveCouncil />} />
        <Route path='/hi/प्रशासन/वैधानिक-निकाय/विद्वत-परिषद्' element={<AcademicCouncil />} />
        <Route path='/hi/प्रशासन/वैधानिक-निकाय/वित्त-समिति' element={<FinanceCommittee />} />
        <Route path='/hi/प्रशासन/वैधानिक-निकाय/शैक्षणिक-योजना-बोर्ड' element={<AcademicPlanningBoard />} />
        <Route path='/hi/प्रशासन/वैधानिक-निकाय/विश्वविद्यालय-कोर्ट' element={<UniversityCourt />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/कुलाधिपति' element={<Chancellor />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/कुलपति' element={<ViceChancellor />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/कुलसचिव' element={<Registrar />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/कुलानुशासक' element={<Proctor />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/शैक्षणिक-अधिष्ठाता' element={< DeanofAcademics />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/छात्र-कल्याण-अधिष्ठाता' element={<DeanofStudentWelfare />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/महाविद्यालय-अधिष्ठाता' element={<DeanofColleges />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/मुख्य-संरक्षक' element={<ChiefWarden />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/वित्ताधिकारी' element={<FinanceOfficer />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/परीक्षा-नियंत्रक' element={<ControllerofExaminations />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/पुस्तकालयाध्यक्ष' element={<ChiefLibrarian />} />
        <Route path='/hi/प्रशासन/विश्वविद्यालय-के-अधिकारी/अधिष्ठाता' element={<FacultyHead />} />
        <Route path='/hi/प्रशासन/लोकपाल' element={<Ombudsman />} />
        <Route path='/hi/प्रशासन/कार्यालय-अनुभाग' element={<Department />} />
        <Route path='/hi/प्रशासन/विशेष-सेल-एवं-समितियां' element={<SpecialCellsCommittees />} />



        <Route path='/hi/शैक्षणिक/संकाय-एवं-विभाग/वेद-वेदांग-संकाय/वेद-विभाग' element={<VedaDepartment />} />
        <Route path='/hi/शैक्षणिक/संकाय-एवं-विभाग/वेद-वेदांग-संकाय/व्याकरण-विभाग' element={<GrammarDepartments />} />
        <Route path='/hi/शैक्षणिक/संकाय-एवं-विभाग/वेद-वेदांग-संकाय/ज्योतिष-विभाग' element={<AstrologyDepartment />} />
        <Route path='/hi/शैक्षणिक/संकाय-एवं-विभाग/वेद-वेदांग-संकाय/धर्मशास्त्र-विभाग' element={<DepartmentDharmaStudies />} />
        <Route path='/hi/शैक्षणिक/संकाय-एवं-विभाग/साहित्य-एवं-संस्कृति-संकाय/साहित्य-विभाग' element={<LiteratureDepartment />} />
        <Route path='/hi/शैक्षणिक/संकाय-एवं-विभाग/साहित्य-एवं-संस्कृति-संकाय/हिंदू-अध्ययन-विभाग' element={<DepartmentHinduStudies />} />
        <Route path='/hi/शैक्षणिक/संकाय-एवं-विभाग/दर्शन-संकाय/दर्शन-विभाग' element={<FacultyPhilosophy />} />
        <Route path='/hi/शैक्षणिक/संकाय-एवं-विभाग/दर्शन-संकाय/योग-विभाग' element={<DepartmentYoga />} />
        <Route path='/hi/शैक्षणिक/शोध-एवं-प्रकाशन' element={<ResearchandPublication />} />
        <Route path='/hi/शैक्षणिक/शोध-केंद्र-पीठ/सरस्वती-सभ्यता-शोध-केंद्र' element={<SaraswatiCivilizationResearchCenter />} />
        <Route path='/hi/शैक्षणिक/शोध-केंद्र-पीठ/कठ-कपिष्ठल-शोध-केंद्र' element={<KathKapisthalaResearchCenter />} />
        <Route path='/hi/शैक्षणिक/शोध-केंद्र-पीठ/महर्षि-वाल्मीकि-शोध-केंद्र' element={<MaharishiValmikiResearchCenter />} />
        <Route path='/hi/शैक्षणिक/शोध-केंद्र-पीठ/भारतीय-ज्ञानपरम्परा-शोध-एवं-प्रशिक्षण-केंद्र' element={<IndianKnowledgeTraditionResearchTrainingCenter />} />
        <Route path='/hi/शैक्षणिक/शोध-केंद्र-पीठ/48-कोस-कुरुक्षेत्र-तीर्थ-शोध-एवं-प्रशिक्षण-केन्द्र' element={<KosKurukshetraResearchTrainingCenter />} />
        <Route path='/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/वेद-डिप्लोमा' element={<VedaDiploma />} />
        <Route path='/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/वास्तुशास्त्र-डिप्लोमा' element={<VastuShastraDiploma />} />
        <Route path='/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/कर्मकांड-पौरोहित्य-डिप्लोमा' element={<KarmakandaPourohityaDiploma />} />
        <Route path='/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/ज्योतिष-डिप्लोमा' element={<JyotishDiploma />} />
        <Route path='/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/योग-डिप्लोमा' element={<YogaDiploma />} />
        <Route path='/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/संस्कृत-भाषा-दक्षता-डिप्लोमा' element={<SanskritBhashaDakshataDiploma />} />
        <Route path='/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/गीता-में-जीवन-प्रबंधन-डिप्लोमा' element={<GitaMeJeevanPrabandhanDiploma />} />
        <Route path='/hi/शैक्षणिक/डिप्लोमा-एवं-अन्य-प्रशिक्षण-केंद्र/अंग्रेजी-हिंदी-अंग्रेजी-अनुवाद-डिप्लोमा' element={< EnglishHindiEnglishTranslationDiploma />} />
        <Route path='/hi/शैक्षणिक/शैक्षणिक-दिनदर्शिका' element={< AcademicCalendar />} />
        <Route path='/hi/शैक्षणिक/समय-सारिणी' element={< TimetableTable />} />
        <Route path='/hi/शैक्षणिक/गतिविधियां/एन-सी-सी' element={< NCC />} />
        <Route path='/hi/शैक्षणिक/गतिविधियां/एन-एस-एस' element={< NSS />} />
        <Route path='/hi/शैक्षणिक/गतिविधियां/क्रीड़ा-एवं-खेल' element={< SportsandGames />} />
        <Route path='/hi/शैक्षणिक/गतिविधियां/सांस्कृतिक-गतिविधियां' element={< CulturalActivities />} />
        <Route path='/hi/शैक्षणिक/पंजीकृत-शोध-छात्र' element={< RegisteredResearchScholars />} />
        <Route path='/hi/शैक्षणिक/दीक्षांत-समारोह' element={< Convocation />} />
        <Route path='/hi/शैक्षणिक/पाठ्यक्रम' element={< Curriculum />} />

        <Route path='/hi/प्रवेश' element={< Entry />} />
        <Route path='/hi/पुस्तकालय' element={< Library />} />
        <Route path='/hi/परीक्षा' element={< Exam />} />
        <Route path='/hi/सुविधाएं/छात्रावास' element={< Dormitory />} />
        <Route path='/hi/सुविधाएं/अतिथिगृह' element={< GuestHouse />} />
        <Route path='/hi/सुविधाएं/स्वास्थ्य-केंद्र' element={< HealthCenter />} />
        <Route path='/hi/सुविधाएं/यज्ञशाला' element={< YajnaHall />} />
        <Route path='/hi/सुविधाएं/कम्प्यूटर-लैब' element={< ComputerLab />} />
        <Route path='/hi/सुविधाएं/योगशाला' element={< YogaHall />} />
        <Route path='/hi/सुविधाएं/क्रीडास्थल' element={< SportsandGames />} />
        <Route path='/hi/सुविधाएं/कैण्टीन' element={< Canteen />} />

        <Route path='/hi/विज्ञप्ति-एवं-निविदा' element={< NoticesandTenders />} />
        <Route path='/hi/सूचना-का-अधिकार' element={< RighttoInformation />} />
        <Route path='/hi/संपर्क/स्टाफ-डायरेक्ट्री' element={< StaffDirectory />} />



        <Route path='/hi/संपर्क/कुलपति-कार्यालय' element={< ViceChancellorsOffice />} />
        <Route path='/hi/संपर्क/कुलसचिव-कार्यालय' element={< RegistrarOffice />} />

        <Route path='/hi/संपर्क/विश्वविद्यालय-के-अधिकारी' element={< UniversityOfficials />} />
        <Route path='/hi/संपर्क/जनसंपर्क-अधिकारी-कार्यालय' element={< PublicRelationsOfficerOffice />} />
        <Route path='/hi/सहायता' element={< Help />} />
        <Route path='/hi/विविध' element={< Miscellaneous />} />
        <Route path='/hi/छात्रवृत्ति' element={<Scholarship />} />
        <Route path='/hi/साइट-मैप' element={<SiteMap />} />

        <Route path='/hi/सूचनाएं' element={<ViewAllNotices />} />

        <Route path="/hi/gallery" element={<GalleryPage />} />



        {/* <Route path='/en' element={<Home_Eng />} /> */}
        {/* <Route path='/en/' element={<Header_Eng />} /> */}
        {/* <Route path='/en/university/about-university' element={<About_Eng />} /> */}
        {/* <Route path='/en/university/vision-and-mission' element={<VisionandMission_Eng />} /> */}
        {/* <Route path='/en/university/chancellor-message' element={<Chancellormessage_Eng />} /> */}
        {/* <Route path='/en/university/vice-chancellor-message' element={<ViceChancellormessage_Eng />} /> */}
        {/* <Route path='/en/university/registrar-message' element={<Registrarmessage_Eng />} /> */}
        {/* <Route path='/en/university/university-anthem' element={<UniversityAnthem_Eng />} /> */}
        {/* <Route path='/en/university/university-act' element={<UniversityAct_Eng />} /> */}
        {/* <Route path='/en/university/campus-view' element={<CampusView_Eng />} /> */}
        {/* <Route path='/en/university/guide-map' element={<GuideMap_Eng />} /> */}
        {/* <Route path='/en/university/university-staff' element={<UniversityStaff_Eng />} /> */}

        {/* <Route path='/en/administration/statutory-bodies/executive-council' element={<ExecutiveCouncil_Eng />} /> */}
        {/* <Route path='/en/administration/statutory-bodies/academic-council' element={<AcademicCouncil_Eng />} /> */}
        {/* <Route path='/en/administration/statutory-bodies/finance-committee' element={<FinanceCommittee_Eng />} /> */}
        {/* <Route path='/en/administration/statutory-bodies/academic-planning-board' element={<AcademicPlanningBoard_Eng />} /> */}
        {/* <Route path='/en/administration/statutory-bodies/university-court' element={<UniversityCourt_Eng />} /> */}

        {/* <Route path='/en/administration/university-officers/chancellor' element={<Chancellor_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/vice-chancellor' element={<ViceChancellor_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/registrar' element={<Registrar_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/proctor' element={<Proctor_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/dean-of-academics' element={< DeanofAcademics_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/dean-of-student-welfare' element={<DeanofStudentWelfare_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/dean-of-colleges' element={<DeanofColleges_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/chief-warden' element={<ChiefWarden_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/finance-officer' element={<FinanceOfficer_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/controller-of-examinations' element={<ControllerofExaminations_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/chief-librarian' element={<ChiefLibrarian_Eng />} /> */}
        {/* <Route path='/en/administration/university-officers/faculty-head' element={<FacultyHead_Eng />} /> */}
        {/* <Route path='/en/administration/ombudsman' element={<Ombudsman_Eng />} /> */}
        {/* <Route path='/en/administration/offices-departments' element={<Department_Eng />} /> */}

        {/* <Route path='/en/administration/department' element={<Department_Eng />} /> */}
        {/* <Route path='/en/administration/special-cells-committees' element={<SpecialCellsCommittees_Eng />} /> */}
        {/* <Route path='/en/academics/faculty-departments/veda-vedanga-faculty/veda-department' element={<VedaDepartment_Eng />} /> */}
        {/* <Route path='/en/academics/faculty-departments/veda-vedanga-faculty/grammar-department' element={<GrammarDepartment_Eng />} /> */}
        {/* <Route path='/en/academics/faculty-departments/veda-vedanga-faculty/astrology-department' element={<AstrologyDepartment_Eng />} /> */}
        {/* <Route path='/en/academics/faculty-departments/veda-vedanga-faculty/dharma-studies-department' element={<DepartmentDharmaStudies_Eng />} /> */}
        {/* <Route path='/en/academics/faculty-departments/literature-culture-faculty/literature-department' element={<LiteratureDepartment_Eng />} /> */}
        {/* <Route path='/en/academics/faculty-departments/literature-culture-faculty/hindu-studies-department' element={<DepartmentHinduStudies_Eng />} /> */}
        {/* <Route path='/en/academics/faculty-departments/philosophy-faculty/philosophy-department' element={<FacultyPhilosophy_Eng />} /> */}
        {/* <Route path='/en/academics/faculty-departments/philosophy-faculty/yoga-department' element={<DepartmentYoga_Eng />} /> */}

        {/* <Route path='/en/academics/research-publication' element={<ResearchandPublication_Eng />} /> */}
        {/* <Route path='/en/academics/research-center-chairs/saraswati-civilization-research-center' element={<SaraswatiCivilizationResearchCenter_Eng />} /> */}
        {/* <Route path='/en/academics/research-center-chairs/kath-kapisthala-research-center' element={<KathKapisthalaResearchCenter_Eng />} /> */}
        {/* <Route path='/en/academics/research-center-chairs/maharishi-valmiki-research-center' element={<MaharishiValmikiResearchCenter_Eng />} /> */}
        {/* <Route path='/en/academics/research-center-chairs/indian-knowledge-tradition-research-training-center' element={<IndianKnowledgeTraditionResearchTrainingCenter_Eng />} /> */}
        {/* <Route path='/en/academics/research-center-chairs/48-kos-kurukshetra-pilgrimage-research-training-center' element={<KosKurukshetraResearchTrainingCenter_Eng />} /> */}

        {/* <Route path='/en/academics/diploma-other-training-centers/veda-diploma' element={<VedaDiploma_Eng />} /> */}
        {/* <Route path='/en/academics/diploma-other-training-centers/vastu-shastra-diploma' element={<VastuShastraDiploma_Eng />} /> */}
        {/* <Route path='/en/academics/diploma-other-training-centers/karmakanda-pourohitya-diploma' element={<KarmakandaPourohityaDiploma_Eng />} /> */}
        {/* <Route path='/en/academics/diploma-other-training-centers/jyotish-diploma' element={<JyotishDiploma_Eng />} /> */}
        {/* <Route path='/en/academics/diploma-other-training-centers/yoga-diploma' element={<YogaDiploma_Eng />} /> */}
        {/* <Route path='/en/academics/diploma-other-training-centers/sanskrit-language-proficiency-diploma' element={<SanskritBhashaDakshataDiploma_Eng />} /> */}
        {/* <Route path='/en/academics/diploma-other-training-centers/life-management-in-gita-diploma' element={<GitaMeJeevanPrabandhanDiploma_Eng />} /> */}
        {/* <Route path='/en/academics/diploma-other-training-centers/english-hindi-english-translation-diploma' element={< EnglishHindiEnglishTranslationDiploma_Eng />} /> */}

        {/* <Route path='/en/admissions' element={< Entry_Eng />} /> */}
        {/* <Route path='/en/library' element={< Library_Eng />} /> */}
        {/* <Route path='/en/examinations' element={< Exam_Eng />} /> */}

        {/* <Route path='/en/notices-tenders' element={< NoticesandTenders_Eng />} /> */}
        {/* <Route path='/en/right-to-information' element={< RighttoInformation_Eng />} /> */}
        {/* <Route path='/en/contact/staff-directory' element={< StaffDirectory_Eng />} /> */}
        {/* <Route path='/en/miscellaneous' element={< Miscellaneous_Eng />} /> */}
        {/* <Route path='/en/academics/academic-calendar' element={<AcademicCalendar_Eng />} /> */}
        {/* <Route path='/en/academics/timetable' element={< Timetable_Eng />} /> */}
        {/* <Route path='/en/academics/activities/ncc' element={< NCC_Eng />} /> */}
        {/* <Route path='/en/academics/activities/nss' element={< NSS_Eng />} /> */}
        {/* <Route path='/en/academics/activities/sports-games' element={< SportsandGames_Eng />} /> */}
        {/* <Route path='/en/academics/activities/cultural-activities' element={< CulturalActivities_Eng />} /> */}
        {/* <Route path='/en/academics/registered-research-scholars' element={< RegisteredResearchScholars_Eng />} /> */}
        {/* <Route path='/en/academics/convocation' element={< Convocation_Eng />} /> */}
        {/* <Route path='/en/academic/curriculum' element={< Curriculum_Eng />} /> */}

        {/* <Route path='/en/facilities/dormitory' element={< Dormitory_Eng />} /> */}
        {/* <Route path='/en/facilities/guest-house' element={< GuestHouse_Eng />} /> */}
        {/* <Route path='/en/facilities/health-center' element={< HealthCenter_Eng />} /> */}
        {/* <Route path='/en/facilities/yajna-hall' element={< YajnaHall_Eng />} /> */}
        {/* <Route path='/en/facilities/computer-lab' element={< ComputerLab_Eng />} /> */}
        {/* <Route path='/en/facilities/yoga-hall' element={< YogaHall_Eng />} /> */}
        {/* <Route path='/en/facilities/sports-ground' element={< SportsandGames_Eng />} /> */}
        {/* <Route path='/en/facilities/canteen' element={< Canteen_Eng />} /> */}

        {/* <Route path='/en/contact/vice-chancellor-office' element={< ViceChancellorsOffice_Eng />} /> */}
        {/* <Route path='/en/contact/registrar-office' element={< RegistrarOffice_Eng />} /> */}
        {/* <Route path='/en/contact/university-officials' element={< UniversityOfficials_Eng />} /> */}
        {/* <Route path='/en/contact/public-relations-officer-office' element={< PublicRelationsOfficerOffice_Eng />} /> */}
        {/* <Route path='/en/help' element={< Help_Eng />} /> */}
        {/* <Route path='/en/miscellaneous' element={< Miscellaneous_Eng />} /> */}
        {/* <Route path="/en/gallery" element={<GalleryPage />} /> */}

        {/* <Route path="/registartionForm" element={<RegistrationForm />} /> */}




        <Route path="*" element={<NotFoundPage />} />


      </Routes>

    </>

  );
}


function AppNav() {

  const [visitorCount, setVisitorCount] = useState(null);

  useEffect(() => {
    const trackVisitor = async () => {
      try {
        const res = await axios.post(`${BaseUrl}/api/visitor/track`);
        if (res.data) {
          setVisitorCount(res.data);
        }
      } catch (err) {
        console.error("Error tracking visitor:", err);
      }
    };

    trackVisitor();
  }, []);

  const location = useLocation();
  const hideLayout = ["/dashboard", "/dashboard/home", "/dashboard/upload-images", "/dashboard/upload-notifications", "/dashboard/upload-curriculum",].includes(location.pathname);
  const hideFooter = ["/dashboard", "/dashboard/home", "/dashboard/upload-images", "/dashboard/upload-notifications", "/dashboard/upload-curriculum", "/login",].includes(location.pathname);
  // const header_eng = ["/en"].includes(location.pathname);
  const header_eng = location.pathname.startsWith("/en");

  const header_hindi = location.pathname.startsWith("/hi");

  return (
    <>
      {!hideLayout && header_hindi && <Header />}

      {!hideLayout && header_eng && <Header />}
      {!hideLayout && header_hindi && <NavbarMenu />}
      {!hideLayout && header_eng && <Navbar_Eng />}

      {!hideFooter && <AppContent />}
      <Routes>
        <Route path='/' element={<Navigate to="/hi" replace />} />
        <Route path='/login' element={<Login />} />
        <Route path="dashboard" element={<Dashboard />}>
          <Route path="home" element={<Home1 />} />
          <Route path="hi" element={<Home1 />} />
          <Route path="upload-images" element={<Images />} />
          <Route path="upload-notifications" element={<Notifications1 />} />
          <Route path="upload-sale-rates" element={<Links />} />
          <Route path="upload-directory" element={<Directory />} />
          <Route path="upload-curriculum" element={<BlockNotifications />} />
        </Route>
      </Routes>
      {!hideFooter && header_hindi && <Footer visitorCount={visitorCount} />}
      {!hideFooter && header_eng && <Footer_Eng visitorCount={visitorCount} />}

      <ToastContainer position="top-center" hideProgressBar="true" autoClose={3000} />

    </>
  );
}

function App() {
  return (
    <Router>
      <AppNav />
    </Router>
  );
}





export default App;
